
<template>
    <svg t="1570869728120" class="icon" viewBox="0 0 1024 1024" version="1.1" p-id="634" width="200" height="200">
        <path d="M758.4 888.32H272.64c-63.36 0-115.2-51.84-115.2-115.2V287.36c0-63.36 51.84-115.2 115.2-115.2h491.52c60.16 0 109.44 49.28 109.44 109.44v30.08c0 17.92-14.08 32-32 32s-32-14.08-32-32V281.6c0-24.96-20.48-45.44-45.44-45.44H272.64c-28.16 0-51.2 23.04-51.2 51.2v485.76c0 28.16 23.04 51.2 51.2 51.2h485.76c28.16 0 51.2-23.04 51.2-51.2v-249.6c0-17.92 14.08-32 32-32s32 14.08 32 32v249.6c0 63.36-51.84 115.2-115.2 115.2z" fill="#1890ff" p-id="635"></path><path d="M464.64 727.68c-8.32 0-16.64-3.2-22.4-9.6L279.04 554.88c-12.8-12.8-12.8-32.64 0-45.44s32.64-12.8 45.44 0l140.8 140.8 351.36-352.64c12.8-12.8 32.64-12.8 45.44 0s12.8 32.64 0 45.44l-374.4 375.04c-6.4 5.76-14.08 9.6-23.04 9.6z" fill="#1890ff" p-id="636">
        </path>
    </svg>
</template>
<script>
export default {
    name: 'selectall',
    components: {
    },
    created() {
    }
}
</script>
